function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Flex, Container } from '@olxbr/ds-web';
import { TextContainer } from './styles';
export function IconCard(_ref) {
  var content = _ref.content,
    getStyledText = _ref.getStyledText,
    isMobile = _ref.isMobile;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    icon = _useState2[0],
    setIcon = _useState2[1];
  useEffect(function () {
    var size = isMobile ? 64 : 96;
    var Icon = require('@olxbr/ds-spots')[content.iconName];
    setIcon( /*#__PURE__*/React.createElement(Icon, {
      shape: content.iconShape,
      size: size
    }));
  }, [content.iconName, content.iconShape, isMobile]);
  if (!content.iconName) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(Container, {
    type: "outlined",
    flexDirection: "column"
  }, getStyledText("title", content.title, content === null || content === void 0 ? void 0 : content.badgeText, content === null || content === void 0 ? void 0 : content.badgeColor), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    marginTop: "--spacing-1"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "96px"
    }
  }, icon), isMobile ? /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement("span", null, getStyledText("description", content.description))) : getStyledText("description", content.description)));
}
IconCard.propTypes = {
  getStyledText: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired
};
export default IconCard;